import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Checkbox, Form, Spin } from "antd";
// import PaymentGateway from "../../../helpers/PaymentGateway";
import "./HotelCheckout.scss";
import { LoadingOutlined } from "@ant-design/icons";
import PayGateway from "../../../helpers/PayGateway";
import GlobalStatesContext from "../../../common/providers/GlobalStatesContext";
import PayMentSelection from "../../../common/PaymentSelection/PaymentSelection";
import { useAuthContext } from "../../../common/providers/AuthProvider";

const HotelBookPayCard = (props) => {
  const {user,isLogin: { agent },} = useAuthContext();
  const [form] = Form.useForm();
  const { state: {SeletedPayOption}, OnPaymentModeSelection} = useContext(GlobalStatesContext);
  const [value, setValue] = useState();
  const [Deposit, setDeposit] = useState(false);

  const goTo = () => {
    if (props.bookpaycardinfo === "hotel-review") {
      props.processPayGateway(1);
    } else if (props.bookpaycardinfo === "hotel-checkout") {
      props.redirectToPreview();
    }
  };

  useEffect(() => {
    if ((user?.Deposit?.filter(x => x == 2) == 2)) {
      setDeposit(true)
    }
  }, [user])

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );

  return (
    <React.Fragment>
    <Card bordered={false} className="hotel-card-wrapper book-pay-card">
      {props.pgIsLoading ? (
        // <PaymentGateway data={props.pgData} />
          <PayGateway
            blockApiReq={props.blockApiReq}
            loadingSpin={props.loadingSpin}
            OnPaymentModeSelection={OnPaymentModeSelection}
            IsDeposit={Deposit}
          />
      ) : (
        <Form form={form} onFinish={goTo}>
          {props.bookpaycardinfo === "hotel-checkout" ? (
            <div className="book-pay-tc">
              <Form.Item
                name="remember"
                rules={[
                  {
                    validator: (rule, value) => {
                      return value
                        ? Promise.resolve()
                        : Promise.reject("Accept Terms & Conditions");
                    },
                  },
                ]}
                valuePropName="checked"
              >
                <Checkbox>
                  I Agree To All The{" "}
                  <a
                    href="/termsofconditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" Terms & Conditions"}{" "}
                  </a>{" "}
                  and{" "}
                  <a
                    href="/privacypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    Privacy Policy.
                  </a>
                </Checkbox>
              </Form.Item>
            </div>
          ) : null}
          <div className="d-flex flex-wrap">
            <div className="book-pay-btn mr-2 mb-1">
              <Button
                disabled={props.isLoading}
                className="btn btn-md"
                htmlType="submit"
              >
                {props.pgIsLoading ? (
                  <Spin indicator={antIcon} />
                ) : props.bookpaycardinfo === "hotel-checkout" ? (
                  "Continue"
                ) : (
                  "Pay and Book"
                )}
              </Button>
            </div>

            {props.bookpaycardinfo === "hotel-review" &&
            props.purchaseType === "Block" &&
            props.agent ? (
              <div className="book-pay-btn mb-1">
                {props.holdLoading ? (
                  <Button className="btn btn-md">
                    <Spin indicator={antIcon} />
                  </Button>
                ) : (
                  <Button
                    className="btn btn-md"
                    onClick={() => props.processPayGateway(2)}
                  >
                    Hold Hotel
                  </Button>
                )}
              </div>
            ) : null}
          </div>
        </Form>
      )}
    </Card>
    {SeletedPayOption != true ? null : <PayMentSelection setValue={setValue} value={value} />}
    </React.Fragment>
  );
};

export default HotelBookPayCard;
